export default __webpack_public_path__ + "static/media/fb-taraftart-card-with-bg.50e5cfdd.png";